import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { NotificationType } from 'angular2-notifications'
import { AppNotificationService } from '../app-notification.service'
import * as errorKeys from './error-keys.json'

@Injectable({
   providedIn: 'root'
})
export class AppErrorHandlerService {
   constructor(private _notificationService: AppNotificationService) {}

   handleError(errorResponse: HttpErrorResponse) {
      const isConnectionFailed = errorResponse.status === 0
      const isClientError = errorResponse.status >= 400 && errorResponse.status < 500
      let type = isConnectionFailed || isClientError ? NotificationType.Warn : NotificationType.Error
      let errorKey = ''

      isConnectionFailed ? (errorKey = 'error_key_network') : (errorKey = errorResponse.error?.detail)

      this._notificationService.notify(type, undefined, errorKeys[errorKey as keyof typeof errorKeys] ?? 'We couldn’t complete your request. Please try again.')
   }
}
